"use strict";
// Copyright © 2022 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineHeaderContent = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../../dsl/front");
/**
 * Component capable of rendering the `TeaserBoxModule's` header.
 *
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
let LineHeaderContent = class LineHeaderContent extends vue_property_decorator_1.Vue {
};
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: false }),
    __metadata("design:type", Object)
], LineHeaderContent.prototype, "headerImage", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false }),
    __metadata("design:type", String)
], LineHeaderContent.prototype, "headerLink", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: true }),
    __metadata("design:type", Object)
], LineHeaderContent.prototype, "text", void 0);
LineHeaderContent = __decorate([
    vue_property_decorator_1.Component({
        name: 'LineHeaderContent',
        components: { BootstrapImage: front_1.BootstrapImage, BootstrapNav: front_1.BootstrapNav, BootstrapLink: front_1.BootstrapLink },
        template: `
    <BootstrapLink v-if="headerLink" :link="{target: { path: headerLink }}" style="text-decoration: none">
      <BootstrapImage v-if="headerImage" v-bind="headerImage" class="teaser-box__header__image" />
      <template v-else>
        {{ text }}
      </template>
    </BootstrapLink>
    <span v-else>
      <BootstrapImage v-if="headerImage" v-bind="headerImage" class="teaser-box__header__image" />
      <template v-else>
        {{ text }}
      </template>
    </span>
  `
    })
], LineHeaderContent);
exports.LineHeaderContent = LineHeaderContent;
//# sourceMappingURL=LineHeaderContent.js.map